<template>
  <div>
    <RightDrawer v-if="!mobile" width="300"></RightDrawer>
    <v-container v-if="!mobile" fluid class="mx-12 my-2">
      <div>
        <v-row>
          <v-col v-if="access.read" cols="12" sm="6" md="4">
            <div class="card-label d-flex flex-row mb-4">
              <v-icon>mdi-account-multiple-outline</v-icon>
              <p class="mb-0 ml-4 subtitle-2 font-weight-bold">Occupancy</p>
            </div>
            <v-card
              v-if="!loading"
              id="occupancy"
              elevation="0"
              hover
              @click="$router.push('units')"
            >
              <Occupancy
                ref="occupancyChart"
                class="pa-4"
                :chart-data="occupancyData"
                :total="totalBeds"
              >
              </Occupancy>
            </v-card>
            <v-skeleton-loader
              v-else
              ref="skeleton"
              type="card"
              loading
              class="mx-auto"
              max-width="300"
            ></v-skeleton-loader>
          </v-col>
          <v-col v-if="access.read" cols="12" sm="6" md="4">
            <div class="card-label d-flex flex-row mb-4">
              <v-icon>mdi-calendar-clock</v-icon>
              <p class="mb-0 ml-4 subtitle-2 font-weight-bold">Due</p>
            </div>
            <v-card v-if="!loading" id="due" hover elevation="0">
              <Due class="pa-4" :chart-data="dueData"> </Due>
            </v-card>
            <v-skeleton-loader
              v-else
              ref="skeleton"
              type="card"
              loading
              class="mx-auto"
              max-width="300"
            ></v-skeleton-loader>
          </v-col>
          <v-col v-if="access.read" cols="12" sm="6" md="4">
            <div class="card-label d-flex flex-row mb-4">
              <v-icon>mdi-alert-circle-outline</v-icon>
              <p class="mb-0 ml-4 subtitle-2 font-weight-bold">
                Open Complaints
              </p>
            </div>
            <v-card
              v-if="!loading"
              id="complaints"
              hover
              elevation="0"
              @click="$router.push('complaints')"
            >
              <Complaints :open-complaints="complaintsCount"> </Complaints>
            </v-card>
            <v-skeleton-loader
              v-else
              ref="skeleton"
              type="card"
              loading
              class="mx-auto"
              max-width="300"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
        <v-row v-if="access.read">
          <v-col cols="12" sm="12" md="12">
            <div class="card-label d-flex flex-row mb-4">
              <v-icon>mdi-calendar-clock</v-icon>
              <p class="mb-0 ml-4 subtitle-2 font-weight-bold">
                Monthly On-Time Payments
              </p>
            </div>
            <v-card
              v-if="!loading"
              id="payments"
              hover
              elevation="0"
              @click="$router.push('payments')"
            >
              <MonthlyOnTime class="pa-4" :chart-data="monthlyOnTimeData">
              </MonthlyOnTime>
            </v-card>
            <v-skeleton-loader
              v-else
              ref="skeleton"
              type="table"
              loading
              class="mx-auto"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </div>
    </v-container>
    <v-container v-else class="pa-0">
      <!--MOBILE VIEW CODE -->
      <v-tabs v-model="mobileTab" class="mb-8" grow height="40">
        <!-- <v-tab class="font-weight-bold"> DASHBOARD </v-tab>
        <v-tab class="font-weight-bold"> DATES </v-tab> -->
        <v-tab> <v-icon> mdi-monitor-dashboard </v-icon> </v-tab>
        <v-tab> <v-icon> mdi-calendar-blank-multiple </v-icon> </v-tab>
      </v-tabs>
      <v-tabs-items v-model="mobileTab">
        <v-tab-item>
          <v-card color="#f4f7f9" class="px-6" flat>
            <v-row class="mb-2">
              <div class="card-label d-flex flex-row">
                <v-icon>mdi-account-multiple-outline</v-icon>
                <p class="mb-0 ml-4 subtitle-2 font-weight-bold">Occupancy</p>
              </div>
            </v-row>
            <v-row class="mb-8">
              <v-card
                v-if="!loading"
                id="occupancy"
                elevation="0"
                hover
                @click="$router.push('units')"
              >
                <Occupancy
                  ref="occupancyChart"
                  class="pa-4"
                  :chart-data="occupancyData"
                  :total="totalBeds"
                >
                </Occupancy>
              </v-card>
              <v-skeleton-loader
                v-else
                ref="skeleton"
                type="card"
                loading
                class="mx-auto"
                max-width="300"
              ></v-skeleton-loader>
            </v-row>
            <v-row class="mb-2">
              <div class="card-label d-flex flex-row">
                <v-icon>mdi-calendar-clock</v-icon>
                <p class="mb-0 ml-4 subtitle-2 font-weight-bold">Due</p>
              </div>
            </v-row>
            <v-row class="mb-8">
              <v-card v-if="!loading" id="due" hover elevation="0">
                <Due class="pa-4" :chart-data="dueData"> </Due>
              </v-card>
              <v-skeleton-loader
                v-else
                ref="skeleton"
                type="card"
                loading
                class="mx-auto"
                max-width="300"
              ></v-skeleton-loader>
            </v-row>
            <v-row v-if="access.read" class="mb-2">
              <div class="card-label d-flex flex-row">
                <v-icon>mdi-alert-circle-outline</v-icon>
                <p class="mb-0 ml-4 subtitle-2 font-weight-bold">
                  Open Complaints
                </p>
              </div>
            </v-row>
            <v-row class="mb-8">
              <v-col class="pa-0 ma-0">
                <v-card
                  v-if="!loading"
                  id="complaints"
                  hover
                  elevation="0"
                  @click="$router.push('complaints')"
                >
                  <Complaints :open-complaints="complaintsCount"> </Complaints>
                </v-card>
                <v-skeleton-loader
                  v-else
                  ref="skeleton"
                  type="card"
                  loading
                  class="mx-auto"
                  max-width="300"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row v-if="access.read" class="mb-2">
              <div class="card-label d-flex flex-row">
                <v-icon>mdi-calendar-clock</v-icon>
                <p class="mb-0 ml-4 subtitle-2 font-weight-bold">
                  Monthly On-Time Payments
                </p>
              </div>
            </v-row>
            <v-row v-if="access.read" class="mb-8">
              <v-card
                v-if="!loading"
                id="payments"
                hover
                elevation="0"
                @click="$router.push('payments')"
              >
                <MonthlyOnTime class="pa-4" :chart-data="monthlyOnTimeData">
                </MonthlyOnTime>
              </v-card>
              <v-skeleton-loader
                v-else
                ref="skeleton"
                type="table"
                loading
                class="mx-auto"
              ></v-skeleton-loader>
            </v-row>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card color="#f4f7f9" class="px-4" flat>
            <RightDrawer width="300"></RightDrawer>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
    <v-tour
      name="dashboardTour"
      :steps="tourSteps"
      :callbacks="tourCallbacks"
      :options="tourOptions"
    ></v-tour>
    <!-- <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay> -->
  </div>
</template>

<script>
import { dayjs } from '../util/date'
import Occupancy from '../components/dashboard/Occupancy'
import Due from '../components/dashboard/Due'
import Complaints from '../components/dashboard/Complaints.vue'
import MonthlyOnTime from '../components/dashboard/MonthlyOnTime'
import Chart from 'chart.js'
import RightDrawer from '../components/RightDrawer.vue'

Chart.defaults.global.defaultFontFamily = 'Nunito'
Chart.defaults.global.defaultFontColor = '#38406a'

export default {
  components: {
    Occupancy,
    Due,
    Complaints,
    MonthlyOnTime,
    RightDrawer
  },
  data() {
    return {
      occupancyData: {
        labels: ['Occupied', 'Vacant'],
        datasets: [
          {
            label: 'Occupancy',
            backgroundColor: ['#00c3e3', '#f87979'],
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#249EBF',
            data: [0, 0]
          }
        ]
      },
      dueData: {
        labels: ['Upcoming', 'Due', 'Overdue'],
        datasets: [
          {
            label: 'Due',
            backgroundColor: ['#00c3e3', '#6fba56', '#f87979'],
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#249EBF',
            data: [0, 0, 0]
          }
        ]
      },
      monthlyOnTimeData: {
        labels: [],
        datasets: [
          {
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], //this.yearRentalPayments.onTimePaymentsCount,
            label: 'On Time Payments',
            backgroundColor: '#00c3e3',
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#249EBF'
          },
          {
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], //this.yearRentalPayments.latePaymentsCount,
            label: 'Late Payments',
            backgroundColor: '#f87979',
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#249EBF'
          }
        ]
      },
      loading: true,
      totalBeds: 0,
      tourSteps: [
        {
          target: '#logo',
          header: {
            title: 'Get Started'
          },
          content:
            'Thanks for using Spacepack! Welcome to your dashboard. Click "next" to see the new features.',
          params: {
            placement: 'bottom'
          },
          offset: -500
        },
        {
          target: '#occupancy',
          header: {
            title: 'Unit Occupancy'
          },
          content:
            'This shows the number of occupied and vacant units in your property.',
          params: {
            placement: 'right'
          },
          offset: -500
        },
        {
          target: '#due',
          header: {
            title: 'Payments'
          },
          content:
            'This shows the number of upcoming, due, and overdue payments.',
          params: {
            placement: 'right'
          },
          offset: -500
        },
        {
          target: '#complaints',
          header: {
            title: 'Complaints and Maintenance'
          },
          content:
            'This shows the number of open complaints from your tenants.',
          params: {
            placement: 'bottom'
          },
          offset: -500
        },
        {
          target: '#payments',
          header: {
            title: 'Payment History'
          },
          content:
            'This shows how many of your tenants have paid on time in the last 12 months.',
          params: {
            placement: 'top'
          },
          offset: 500
        }
      ],
      tourCallbacks: {
        onStop: this.stopTourCallback,
        onFinish: this.finishTourCallback
      },
      upcomingMoveInReservations: [],
      bedsListOccupied: [],
      tourOptions: {
        startTimeout: 2000
        // highlight: true,
      },
      mobileTab: null
    }
  },
  computed: {
    user() {
      return this.$store.getters['auth/getUser']
    },
    complaintsCount() {
      return this.$store.getters['complaints/getPendingCount']
    },
    access() {
      return this.$root.$roleAccess('dashboard_main').access
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  mounted() {
    Promise.all([
      this.$store.dispatch('units/fetchOccupancyAction'),
      this.$store.dispatch('units/fetchDueAction'),
      this.$store.dispatch('payments/fetchYearRentalPaymentsAction'),
      // this.$store.dispatch('reservations/fetchUpcomingMoveInReservationAction'),
      this.$store.dispatch('complaints/fetchPendingComplaintsCountAction')
      // this.$store.dispatch('units/fetchDueTableAction'),
    ]).then((values) => {
      const [occupancyData, dueData, yearRentalPayments] = values
      // set occupanct data
      this.loading = false
      this.occupancyData.datasets[0].data = [
        occupancyData.occupied,
        occupancyData.vacant
      ]
      this.totalBeds = occupancyData.total

      // set due data
      this.dueData.datasets[0].data = [
        dueData.upcoming,
        dueData.due,
        dueData.overdue
      ]

      // set year rental invocies
      const today = dayjs()
      for (let m = 1; m <= 12; m++) {
        this.monthlyOnTimeData.labels.push(today.add(m, 'month').format('MMMM'))
      }

      let latePaymentsCount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      let onTimePaymentsCount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

      if (yearRentalPayments) {
        yearRentalPayments.map((payment) => {
          const startDate = dayjs(payment.startDate)
          let index = startDate.month() - dayjs().month()
          if (index <= 0) index = 11 + index
          if (payment.status === 'paid_late') {
            latePaymentsCount[index] += 1
          } else if (payment.status === 'paid') {
            onTimePaymentsCount[index] += 1
          }
        })

        this.monthlyOnTimeData.datasets[0].data = onTimePaymentsCount
        this.monthlyOnTimeData.datasets[1].data = latePaymentsCount
      }
    })
  },
  updated() {
    if (!this.user.tour || !this.user.tour['dashboard']) {
      this.$tours['dashboardTour'].start()
    } else if (!this.user.tour['rightDrawer']) {
      this.$tours['rightDrawerTour'].start()
    } else if (!this.user.tour['showUnits']) {
      this.$tours['showUnitsTour'].start()
    }
  },
  methods: {
    updateData() {
      this.$refs.occupancyChart.update()
    },
    async stopTourCallback() {
      await this.$store.dispatch('auth/stopTour', { section: 'dashboard' })
    },
    async finishTourCallback() {
      this.$tours['rightDrawerTour'].start()
    }
  }
}
</script>

<style scoped>
.v-card {
  border-radius: 12px !important;
}
#title {
  font-weight: bold;
}
</style>

<style>
.v-step {
  z-index: 999 !important;
}
</style>
